import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button } from '../common'
import { useAuthStore } from '../../store'

interface LoginFormProps {
  onSuccess?: () => void
}

/**
 * Form di login
 */
export default function LoginForm({ onSuccess }: LoginFormProps) {
  const { login, loading, error, clearError } = useAuthStore()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    clearError()

    try {
      await login(email, password)
      onSuccess?.()
    } catch {
      // Errore gestito dallo store
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {/* Errore */}
      {error && (
        <div className="bg-red-500/10 border border-red-500/50 text-red-400 px-4 py-3 rounded-lg text-sm">
          {error}
        </div>
      )}

      {/* Email */}
      <div>
        <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2">
          Email
        </label>
        <input
          type="email"
          id="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full px-4 py-3 bg-night-light border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-gold transition-colors"
          placeholder="tu@esempio.it"
          required
        />
      </div>

      {/* Password */}
      <div>
        <label htmlFor="password" className="block text-sm font-medium text-gray-300 mb-2">
          Password
        </label>
        <input
          type="password"
          id="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full px-4 py-3 bg-night-light border border-gray-700 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:border-gold transition-colors"
          placeholder="••••••••"
          required
        />
      </div>

      {/* Submit */}
      <Button
        type="submit"
        variant="primary"
        className="w-full"
        disabled={loading}
      >
        {loading ? 'Accesso in corso...' : 'Accedi'}
      </Button>

      {/* Link registrazione */}
      <p className="text-center text-gray-400 text-sm">
        Non hai un account?{' '}
        <Link to="/registrati" className="text-gold hover:underline">
          Registrati
        </Link>
      </p>
    </form>
  )
}
